export const SET_CATEGORY_COLLECTION = 'PAYMENT/SET_CATEGORY_COLLECTION';
